export const es = {
	common: {
		languageChanged: "Idioma cambiado",
	},
	translations: {
		content:
			"Este mensaje es renderizado por un componente de React, mostrando elementos interactivos y actualizaciones dinámicas sin recargar toda la página.",
	},
};
